import qs from 'qs'
import { camelizeKeys, decamelizeKeys } from 'humps'

const commaJoinValues = (object: any) => {
  const result: Record<string, any> = {}
  Object.keys(object).forEach(key => {
    const value = object[key]
    result[key] = Array.isArray(value) ? value.join(',') : value
  })
  return result
}

const commaSplitValues = (object: any) => {
  const result: Record<string, any> = {}
  Object.keys(object).forEach(key => {
    result[key] = object[key].split(',')
  })
  return result
}

const numericiseValues = (object: any) => {
  const result: Record<string, any> = {}
  Object.keys(object).forEach(key => {
    result[key] = parseInt(object[key], 10)
  })
  return result
}

export const stringify = (query: any) => {
  query = decamelizeKeys(query || {})
  return qs.stringify({
    ...query,
    filter: query.filter && commaJoinValues(query.filter)
  })
}

export const parse = (queryString: any) => {
  const query = camelizeKeys(qs.parse(queryString))
// @ts-expect-error - TS2339 - Property 'filter' does not exist on type 'object'.
  if (query.filter) {
// @ts-expect-error - TS2339 - Property 'filter' does not exist on type 'object'. | TS2339 - Property 'filter' does not exist on type 'object'.
    query.filter = commaSplitValues(query.filter)
  }
// @ts-expect-error - TS2339 - Property 'page' does not exist on type 'object'.
  if (query.page) {
// @ts-expect-error - TS2339 - Property 'page' does not exist on type 'object'. | TS2339 - Property 'page' does not exist on type 'object'.
    query.page = numericiseValues(query.page)
  }
  return query
}

export const setParams = (params?: any | null) => qs.stringify(
  params,
  { addQueryPrefix: true }
)

export const buildPath = ({
  path,
  queryParams,
}: {
  path: string;
  queryParams: {
    [key: string]: any;
  };
}) => {
  if(!path) {
    return ''
  }

  return queryParams ? `${path}?${stringify(queryParams)}` : path
}
